// extracted by mini-css-extract-plugin
module.exports = {"statistics-container":"Statistics_statistics-container__mju5u"};